import React, { Component } from 'react';
import { Modal, Input, Form } from 'antd';

import { ItemTypes } from '../../../../constants/constants';

const { TextArea } = Input;

export default class EditDialog extends Component {
  constructor(props) {
    super(props);
  }

  formRef = React.createRef();

  handleSubmitEditDescription = () => {
    this.formRef.current
      .validateFields()
      .then(async (values) => {
        let promiseMessage = await this.props.onSubmit(values.description, this.props.initialValue.id);
        if (promiseMessage) {
          let field = [
            {
              name: 'description',
              value: values.description,
              errors: [promiseMessage],
            },
          ];
          this.formRef.current.setFields(field);
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  render() {
    const { onHide, initialValue, rootContainer, resourceType } = this.props;

    return (
      <Modal
        title={`Edit ${resourceType === ItemTypes.Directory ? 'folder' : 'file'} description`}
        getContainer={rootContainer}
        width="520px"
        open={true}
        okText="Confirm"
        cancelText="Cancel"
        onCancel={onHide}
        onOk={this.handleSubmitEditDescription}
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          initialValues={{
            description: initialValue.description,
          }}
        >
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: true,
                message: 'Please enter description.',
              },
              {
                pattern: /^[a-zA-Z0-9\ \!\-_\.\,\*'\(\)]+$/,
                message: "Description can contain only letters, numbers, spaces and following symbols - '!-_.,*()’",
              },
              ({ getFieldValue }) => ({
                validator: (_, value) =>
                  value.length >= 255 ? Promise.reject('The description is too long. It can be max 255 symbols long.') : Promise.resolve(),
              }),
            ]}
          >
            <TextArea rows={4} cols={3} placeholder="Please enter description" ref={(input) => input && input.focus()} />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}
